<script>
  export let paxbot = false;
  //--brand-gradient-topdown: linear-gradient(270deg, #ff5f1f 0%, #ff7900 100%);
  $: labelled = $$props["aria-label"] || $$props["aria-labelledby"] || title;
  $: attributes = {
    "aria-hidden": labelled ? undefined : true,
    role: labelled ? "img" : undefined,
    focusable: Number($$props["tabindex"]) === 0 ? true : undefined,
  };
</script>

<svg
  class="arrow"
  class:paxbot="{paxbot === true}"
  height="0.5rem"
  viewBox="0 0 17 10"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...attributes}
  {...$$restProps}
>
  <path
    d="M8.5 9.36707e-05L17 8.50009L16.11 9.39014L8.5 1.77093L0.890041 9.38089L7.86186e-08 8.49084L8.5 9.36707e-05Z"
    fill="currentColor"></path>
</svg>
